import { createRouter, createWebHashHistory } from "vue-router";
import HomePage from "@/views/HomePage.vue";
import AccueilPage    from '@/views/AccueilPage.vue';
import ProfilePage from "@/views/ProfilePage.vue";
import InterventionsPage from "@/views/InterventionsPage.vue";
import EditInterventionPage from "@/views/EditInterventionPage.vue"
import PhotoPage from "@/views/PhotoPage.vue";
import MaintenancePage from "@/views/MaintenancePage.vue";
import TasksPage from "@/views/TasksPage.vue";
import EditTaskPage from "@/views/EditTaskPage.vue";
import DocumentationPage from "@/views/DocumentationPage.vue";
import VersionsPage from "@/views/VersionsPage.vue";
import AdminVersionsPage from "@/views/AdminVersionsPage.vue";
import LogsPage from "@/views/LogsPage.vue";
import InterventionTimePage from "@/views/InterventionTimePage.vue";
import DocPagesPage from "@/views/DocPagesPage.vue";
import AdminDocPagesPage from "@/views/AdminDocPagesPage.vue";

const routes = [
  {
    path: "/",
    name: "Home",
    component: HomePage,
    meta: { title: 'Home' }
  },
  {
    path: "/accueil",
    name: "Accueil",
    component: AccueilPage,
    meta: { title: 'Accueil' }
  },
  {
    path: "/profile",
    name: "Profile",
    component: ProfilePage,
    meta: { requiresAuth: true, title: 'Profil' }    // ← protégé
  },
  {
    path: "/interventions",
    name: "Interventions",
    component: InterventionsPage,
    meta: { requiresAuth: true, title: 'Interventions' }    // ← protégé
  },
  {
    path: '/interventions/:id/edit',
    name: 'intervention-edit',
    component: EditInterventionPage,
    meta: { requiresAuth: true, title: 'Interventions' }
  },
  {
    path: '/photos',
    name: 'Photo',
    component: PhotoPage,
    meta: { requiresAuth: true, title: 'Photos' }
  },
  {
    path: '/maintenance',
    name: 'Maintenance',
    component: MaintenancePage,
    meta: { title: 'Maintenance' }
  },
  {
    path: '/tasks',
    name: 'Tasks',
    component: TasksPage,
    meta: { requiresAuth: true, title: 'Tâches' }
  },
  {
    path: '/tasks/:id/edit',
    name: 'task-edit',
    component: EditTaskPage,
    meta: { requiresAuth: true, title: 'Tâches' }
  },
  {
    path: '/documentation',
    name: 'Documentation',
    component: DocumentationPage,
    meta: { requiresAuth: true, title: 'Documentation' }
  },
  {
    path: '/versions',
    name: 'Versions',
    component: VersionsPage,
    meta: { requiresAuth: true, title: 'Historique des versions' }
  },
  {
    path: '/admin/versions',
    name: 'AdminVersions',
    component: AdminVersionsPage,
    meta: { requiresAuth: true, title: 'Administration des versions' }
  },
  {
    path: '/logs',
    name: 'Logs',
    component: LogsPage,
    meta: { requiresAuth: true, title: 'Logs Système' }
  },
  {
    path: '/intervention-time',
    name: 'InterventionTime',
    component: InterventionTimePage,
    meta: { requiresAuth: true, title: 'Temps d\'Intervention' }
  },
  {
    path: '/docs/:slug(.*)?',
    name: 'DocPages',
    component: DocPagesPage,
    meta: { requiresAuth: true, title: 'Documentation' }
  },
  {
    path: '/admin/docs',
    name: 'AdminDocPages',
    component: AdminDocPagesPage,
    meta: { requiresAuth: true, title: 'Administration - Documentation' }
  }
];

const router = createRouter({
  history: createWebHashHistory(),
  routes
});

// Global route guard
router.beforeEach((to, from, next) => {
  if (to.meta.requiresAuth && !localStorage.getItem('access_token')) {
    return next({ name:'Home' });
  }
  next();
});

router.afterEach((to) => {
  const defaultTitle = 'Mon App'; // Change ce que tu veux ici
  document.title = to.meta.title || defaultTitle;
});

export default router;
